export const ratings = [
  {
    code: "G",
    name: "大众级",
    desc: "内容适合全年龄观看，不涉及成人议题或强烈情感冲突。",
    note: "伦理题材极少落入此档。",
  },
  {
    code: "PG",
    name: "建议家长陪同",
    desc: "含少量可能不适合儿童的内容，建议家长自行把关。",
    note: "部分家庭题材会采用此分级。",
  },
  {
    code: "PG-13",
    name: "13 岁以上建议陪同",
    desc: "主题、语言或有限的情感场面较成熟，13 岁以下需家长陪同。",
    note: "大量主流伦理剧情片的常见档位。",
  },
  {
    code: "R",
    name: "限制级",
    desc: "含成人主题、语言、暴力或亲密场面，17 岁以下需家长或成年监护人陪同。",
    note: "「尺度较大」的作品多集中于此。",
  },
  {
    code: "NC-17",
    name: "成人级",
    desc: "明确面向成年人，可能含较为直接的成人内容，通常禁止 17 岁及以下入场。",
    note: "所谓「大尺度」常被用来指代此档。",
  },
];